<template>
    <div>
        <el-dialog
                title="Payment Details"
                :visible.sync="show_payment_method">

            <payment-method></payment-method>
        </el-dialog>
        <div class="container" style="margin-top:30px">
            <div class="row" style="margin-bottom:30px;">
                <div class="col-md-2">
                </div>
                <div class="col-md-9">
                    <el-switch
                            v-model="by_year"
                            active-color="#FFC857"
                            inactive-color="lightgray">
                    </el-switch>
                    <span>Pay by year for a 25% discount on the monthly fee.</span>
                </div>
            </div>
        </div>
        <div class="container" v-if="pricing">
            <div class="card-deck mb-3 text-center" style="margin-bottom:0px!important">
              <pricing_card
                  :pricing_details="starter_price"
                  label="Starter"
                  :duration_short="duration_short"
                  :limits="starter_limits"
                  :more_info="starter_more_info"
                  v-on:start="start('starter')"
              />

                <pricing_card
                        :pricing_details="pro_price"
                        label="Pro"
                        :duration_short="duration_short"
                        :limits="pro_limits"
                        :more_info="pro_more_info"
                        v-on:start="start('pro')"
                />

                <pricing_card
                        :pricing_details="agency_price"
                        label="Team"
                        :duration_short="duration_short"
                        :limits="agency_limits"
                        :more_info="agency_more_info"
                        v-on:start="start('team')"

                />

            </div>
        </div>
        <div class="container" style="margin-top:0px">
            <div class="row" style="margin-bottom:0px;">
                <div class="col-md-2">
                </div>
                <div class="col-md-9">
                    <p>A digital presence is a single organization's
                    constellation of websites. For instance, an organization
                    might have division sites and international sites — all
                        of these together is a digital presence. <a href="/pricing-details">See pricing details.</a></p>
                    <p>Need bigger/more? No problem.
                        <a href="https://davidhobbsconsulting.com/contact">
                            Just contact us.
                        </a>
                    </p>
                </div>
            </div>
        </div>
      <div class="container">
        <div class="row" style="margin-top:60px;">
          <div class="col-md-2">
          </div>
          <div class="col-md-9">
            <h5>Want to start with a free trial?</h5>
            <p>You will get an automated report
              on the first thousand URLs of your site.</p>
            <button style="float:left" type="button" @click="start_migration()" class="btn btn-outline-primary">Start free migration analysis</button>
            <button style="float:left;margin-left: 10px;" type="button" @click="start_content()" class="btn btn-outline-primary">Start free content analysis</button>

          </div>
        </div>
      </div>
      <div class="container">
        <div class="row" style="margin-top:20px;">
          .
        </div>
      </div>
    </div>
</template>

<script>
    export default {
        name: "Pricing.vue",
        data() {
            return {
                show_payment_method: false,
                by_year: false, // toggle value,
                show_jump_in: false,
                pricing: null,
                current_info: {
                    plan: 'free',
                    currently_paying: "$2,400 / mo",
                    active_urls: 0
                },
                logged_in: false,
            }
        },
        mounted() {
            if (window.logged_in) {
                this.logged_in = true
            }
            axios.get('/api/pricing/plans')
                .then(response => {
                    console.log('PRICING DATA')
                    console.log(response.data)
                    this.pricing = response.data
                })
                .catch(error => {
                    console.log('could not get pricing')
                })
        },
        computed: {
            duration_short: function() {
                if (this.by_year) {
                    return "yr";
                } else {
                    return "mo";
                }
            },
            duration_property: function() {
                if (this.by_year) {
                    return "yearly";
                } else {
                    return "monthly";
                }
            },
            starter_price: function () {
              return this.plan_pricing('starter')[this.duration_property]
            },
            starter_limits: function() {
              return this.plan_pricing('starter').limits
            },
            starter_more_info: function() {
              return this.plan_pricing('starter').more_info
            },
            pro_price: function () {
                return this.plan_pricing('pro')[this.duration_property]
            },
            pro_limits: function() {
                return this.plan_pricing('pro').limits
            },
            pro_more_info: function() {
                return this.plan_pricing('pro').more_info
            },
            agency_price: function () {
                return this.plan_pricing('team')[this.duration_property]
            },
            agency_limits: function() {
                return this.plan_pricing('team').limits
            },
            agency_more_info: function() {
                return this.plan_pricing('team').more_info
            },
        },
        methods: {
            plan_pricing(plan_name) {
                if(this.pricing) {
                    return this.pricing.filter(price => {
                        return price.plan === plan_name
                    })[0]
                } else {
                    return null
                }
            },
            jump_in() {
                this.show_jump_in = true
            },
            start_migration() {
                window.location.href = "/migration/register"
            },
            start_content() {
                window.location.href = "/rot/register"
            },
            async start(type) {
                console.log('start in Pricing.vue')
                console.log(type)
                if (this.logged_in) {
                    window.location.href = "/pay/" + type + "/" + this.duration_property
                } else {
                    window.location.href = "/register/" + type + "/" + this.duration_property
                }
            }
        }
    }
</script>

<style scoped>

</style>